import { createSlice } from '@reduxjs/toolkit'
import {RootState} from './store'
import { IOrder } from '../interface/IOrder'

export const OrdersSlice = createSlice({
  name: 'order',
  initialState: [] as IOrder[]   ,
  reducers: {
   
    clear: (state, action) => {      
      return []      
    },
    decrement: (state, action) => {
      return state.filter(obj => {
          if (obj.OrderUuid === 'ddd') return false
          else return true })
          ;      
    },
    increment: (state, action) => {
      state.push(action.payload)     
    }
  }
})

// Action creators are generated for each case reducer function
export const {  decrement, increment ,clear} = OrdersSlice.actions
export const orderData = (state: RootState)=>state
export default OrdersSlice.reducer